import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
} from '@angular/core';

import { MAX_UNITS_PER_CART_ITEM } from '@shared/constants/constants';

const MIN_QUANTITY = 1;
const MAX_QUANTITY = MAX_UNITS_PER_CART_ITEM;

@Component({
  selector: 'app-quantity-selector',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './quantity-selector.component.html',
  styleUrl: './quantity-selector.component.css',
})
export class QuantitySelectorComponent {
  public readonly disabled = input<boolean>(false);
  public readonly quantity = model<number>(MIN_QUANTITY);

  /** Tope expuesto al template para no repetir el número en el HTML. */
  public readonly maxQuantity = MAX_QUANTITY;

  public increment(): void {
    if (this.disabled()) {
      return;
    }

    this.quantity.update(currentQuantity =>
      Math.min(currentQuantity + 1, MAX_QUANTITY),
    );
  }

  public decrement(): void {
    if (this.disabled()) {
      return;
    }

    this.quantity.update(currentQuantity =>
      Math.max(currentQuantity - 1, MIN_QUANTITY),
    );
  }

  public onInputChange(event: Event): void {
    if (this.disabled()) {
      return;
    }

    const inputElement = event.target as HTMLInputElement;
    const parsedValue = Number.parseInt(inputElement.value, 10);

    const normalizedValue = Number.isNaN(parsedValue)
      ? MIN_QUANTITY
      : Math.min(
        MAX_QUANTITY,
        Math.max(MIN_QUANTITY, parsedValue),
      );

    this.quantity.set(normalizedValue);
  }
}
